import { isOfferBannerRedesign } from 'reactApp/appHelpers/featuresHelpers/features/offerBanner';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { Props } from 'reactApp/ui/BannerOffer/BannerOffer.types';

export const renderBannerOffer = (data: Props) =>
    openPopupHelper({
        popupName: isOfferBannerRedesign ? popupNames.BANNER_OFFER_REDESIGN : popupNames.BANNER_OFFER,
        data,
        onClose: data.onClose,
    });
